import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('./pages/LoginPage/Login')
  },
  {
    path: '/freetrial',
    name: 'freetrial',
    component: () => import('./pages/LoginPage/FreetrialLogin.vue')
  },
  {
    path: '/expired',
    name: 'expired-page',
    component: () => import('./pages/LoginPage/ExpiredAdmin')
  },
  {
    path: '/policy/privacy',
    name: 'policy/privacy',
    component: () => import('./pages/PolicyClausePage/PrivacyPolicyPage')
  },
  {
    path: '/policy/service',
    name: 'policy/service',
    component: () => import('./pages/PolicyClausePage/ServicePolicyPage')
  },
  {
    path: '/mobile-onboarding',
    name: 'mobile-onboarding',
    component: () => import('./pages/mobile-onboarding-page')
  },
  {
    path: '/announce/access-block',
    name: 'access-block',
    component: () => import('./pages/AccessBlockPage/index')
  },
  {
    path: '/announce/data-transfer',
    name: 'data-transfer',
    component: () => import('./pages/DataTransferAnnouncePage/index')
  },
  {
    path: '/',
    name: 'main',
    component: () => import('./pages/Layout/layout'),
    children: [
      {
        path: 'dashboard',
        name: 'main/dashboard',
        meta: {
          title: '대시보드'
        },
        component: () => import('./pages/DashboardPage/index')
      },
      {
        path: 'wods',
        meta: {
          title: '오늘의 운동'
        },
        component: () => import('./pages/WorkoutOfDayPage'),
        children: [
          {
            path: '',
            name: 'main/wod/create',
            meta: {
              title: '오늘의 운동'
            },
            component: () => import('./pages/WorkoutOfDayPage/WorkoutEditForm')
          },
          {
            path: ':workoutId',
            name: 'main/wod/view',
            meta: {
              title: '오늘의 운동'
            },
            component: () => import('./pages/WorkoutOfDayPage/WorkoutViewForm')
          },
          {
            path: ':workoutId/edit',
            name: 'main/wod/edit',
            meta: {
              title: '오늘의 운동'
            },
            component: () => import('./pages/WorkoutOfDayPage/WorkoutEditForm')
          }
        ]
      },
      {
        path: 'course/schedule',
        name: 'main/course/schedule',
        meta: {
          title: '스케줄'
        },
        component: () => import('./pages/SchedulePage/index.vue')
      },
      {
        path: 'course/timetable',
        name: 'main/course/timetable',
        meta: {
          title: '시간표 제작'
        },
        component: () => import('./pages/TimeTableMakerPage/index.vue')
      },
      {
        path: 'schedule',
        redirect: 'course/schedule'
      },
      {
        path: 'locker',
        name: 'main/locker',
        meta: {
          title: '락커'
        },
        component: () => import('./pages/LockerPage/index.vue')
      },
      {
        path: 'fiflbox-notices',
        component: () => import('./pages/FiflboxNoticePage/index'),
        children: [
          {
            path: '',
            name: 'main/fiflbox-notice/list',
            meta: {
              title: 'FIFL 공지사항'
            },
            component: () =>
              import('./pages/FiflboxNoticePage/FiflboxNoticeList')
          },
          {
            path: ':noticeId',
            name: 'main/fiflbox-notice/view',
            meta: {
              title: 'FIFL 공지사항'
            },
            component: () =>
              import('./pages/FiflboxNoticePage/FiflboxNoticeView')
          }
        ]
      },

      {
        path: 'notices',
        component: () => import('./pages/NoticePage/index'),
        children: [
          {
            path: '',
            name: 'main/notice/list',
            meta: {
              title: '공지'
            },
            component: () => import('./pages/NoticePage/NoticeList')
          },
          {
            path: 'create',
            name: 'main/notice/create',
            meta: {
              title: '공지'
            },
            component: () => import('./pages/NoticePage/NoticeEditForm')
          },
          {
            path: ':noticeId',
            name: 'main/notice/view',
            meta: {
              title: '공지'
            },
            component: () => import('./pages/NoticePage/NoticeViewForm')
          },
          {
            path: ':noticeId/edit',
            name: 'main/notice/edit',
            meta: {
              title: '공지'
            },
            component: () => import('./pages/NoticePage/NoticeEditForm')
          }
        ]
      },
      {
        path: 'member',
        name: 'main/member',
        component: () => import('./pages/MemberManagePage/index.vue'),
        children: [
          {
            path: 'valid',
            name: 'main/member/valid',
            meta: {
              title: '유효회원'
            },
            component: () => import('./pages/MemberManagePage/MemberList')
          },
          {
            path: 'expired',
            name: 'main/member/expired',
            meta: {
              title: '만료회원'
            },
            component: () => import('./pages/MemberManagePage/MemberList')
          },
          {
            path: 'waiting',
            name: 'main/member/waiting',
            meta: {
              title: '승인 대기 회원'
            },
            component: () => import('./pages/MemberManagePage/WaitingMember')
          },
          {
            path: 'register',
            name: 'main/member/register',
            meta: {
              title: '회원 등록'
            },
            component: () =>
              import('./pages/MemberManagePage/MemberRegisterPage')
          },
          {
            path: ':id',
            name: 'main/member/detail',
            meta: {
              title: '회원 상세'
            },
            component: () =>
              import('./pages/MemberManagePage/MemberDetail/MemberDetail')
          }
        ]
      },
      {
        path: 'setting',
        name: 'main/setting',
        component: () => import('./pages/ManagementSettingPage/index'),
        children: [
          {
            path: 'policy',
            name: 'main/setting/policy',
            meta: {
              title: '설정'
            },
            component: () => import('./pages/ManagementSettingPage/Policy')
          },
          {
            path: 'course',
            name: 'main/setting/course',
            meta: {
              title: '설정'
            },
            component: () => import('./pages/ManagementSettingPage/Course')
          },

          {
            path: 'instructor',
            name: 'main/setting/instructor',
            meta: {
              title: '설정'
            },
            component: () =>
              import('./pages/ManagementSettingPage/Instructor/index.vue')
          },

          {
            path: 'instructor/role',
            name: 'main/setting/instructor/role',
            meta: {
              title: '설정'
            },
            component: () =>
              import('./pages/ManagementSettingPage/Instructor/InstructorRole/index.vue')
          },

          {
            path: 'membership',
            name: 'main/setting/membership/list',
            meta: {
              title: '설정'
            },
            component: () =>
              import('./pages/ManagementSettingPage/ParentMembership/ParentMembershipList')
          },
          {
            path: 'membership/create',
            name: 'main/setting/membership/create',
            meta: {
              title: '설정'
            },
            component: () =>
              import('./pages/ManagementSettingPage/ParentMembership/MembershipEditForm')
          },
          {
            path: 'membership/:parentMembershipId',
            name: 'main/setting/membership/edit',
            meta: {
              title: '설정'
            },
            component: () =>
              import('./pages/ManagementSettingPage/ParentMembership/MembershipEditForm')
          }
        ]
      },
      {
        path: 'account',
        name: 'main/account',
        meta: {
          title: '계정 관리'
        },
        component: () => import('./pages/AccountPage/index.vue')
      },
      {
        path: 'payment',
        name: 'main/payment',
        meta: {
          title: '결제 정보'
        },
        component: () => import('./pages/PaymentPage')
      },
      {
        path: 'analytics',
        name: 'main/analytics',
        meta: {
          title: '통계'
        },
        component: () => import('./pages/AnalyticsPage/index.vue')
      },
      {
        path: '/referral',
        component: () => import('./pages/ReferralPage/index.vue'),
        children: [
          {
            path: '',
            name: 'referral/dashboard',
            meta: {
              title: '지인초대 & 혜택'
            },
            component: () =>
              import('./pages/ReferralPage/ReferralOverviewPage.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/password/identify',
    name: 'password/identify',
    meta: {
      title: '비밀번호 재설정'
    },
    component: () => import('./pages/LoginPage/PasswordEmailIdentify.vue')
  },
  {
    path: '/reset-password',
    name: 'password/reset-password',
    meta: {
      title: '비밀번호 재설정'
    },
    component: () => import('./pages/LoginPage/PasswordReset.vue')
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: '회원가입'
    },
    component: () => import('./pages/RegisterPage/index.vue')
  },
  {
    path: '/checkin',
    component: () => import('./pages/SelfCheckinPage/index.vue'),
    children: [
      {
        path: '',
        name: 'checkin/check',
        meta: {
          title: '출석체크'
        },
        component: () => import('./pages/SelfCheckinPage/MemberVerifyPage.vue')
      },
      {
        path: 'course',
        name: 'checkin/course',
        meta: {
          title: '출석체크'
        },
        component: () =>
          import('./pages/SelfCheckinPage/AvailableCourseSelectPage.vue')
      },
      {
        path: 'confirm',
        name: 'checkin/confirm',
        meta: {
          title: '출석체크'
        },
        component: () =>
          import('./pages/SelfCheckinPage/MembershipConfirmPage.vue')
      }
    ]
  }
];

export default new Router({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
